import { WellheadCostBase } from './base/wellhead-cost-base';

export class WellheadCost extends WellheadCostBase { }